export const defaultLanguage = {
    "WORKPLUS.HOME_PAGE.HOME": "Home",
    "WORKPLUS.LOGIN_PAGE.PASSWORD": "Password",
    "WORKPLUS.LOGIN_PAGE.COMPANY_CODE": "Company",
    "WORKPLUS.LOGIN_PAGE.SIGNIN": "Sign In",
    "WORKPLUS.LOGIN_PAGE.FORGOT_PASSWORD": "Forgot Password",
    "WORKPLUS.LOGIN_PAGE.SIGNIN_CONTINUE": "Sign in to Work Plus",
    "WORKPLUS.LOGIN_PAGE.WELCOME": "Welcome",
    "WORKPLUS.LOGIN_PAGE.REMEMBER_ME": "Remember Me",
    "WORKPLUS.LOGIN_PAGE.EMAIL": "Email",
    "WORKPLUS.LOGIN_PAGE.GUEST_LOGIN": "Explore demo",
    "WORKPLUS.GREETING_PAGE.DONE": "Done",
    "WORKPLUS.HOME_PAGE.RECENTLY": "Recent Services",
    "WORKPLUS.HOME_PAGE.MORE": "More",
    "WORKPLUS.SCANNER_QR_PAGE.QRSCANBOX": "Scan the QR code in the box",
    "WORKPLUS.FORGOT_PASSWORD_PAGE.FORGOT_PASSWORD": "Forgot Password",
    "WORKPLUS.FORGOT_PASSWORD_PAGE.ENTER_YOUR_EMAIL": "Please enter your email",
    "WORKPLUS.FORGOT_PASSWORD_PAGE.SEND_PROVISIONAL_PASSWORD": "We will send you a provisional password.",
    "WORKPLUS.CHANGE_PASSWORD_PAGE.CURRENT_PASSWORD": "Current Password",
    "WORKPLUS.CHANGE_PASSWORD_PAGE.NEW_PASSWORD": "New Password",
    "WORKPLUS.CHANGE_PASSWORD_PAGE.CONFIRM_NEW_PASSWORD": "Confirm New Password",
    "WORKPLUS.RESET_PASSWORD_PAGE.TITLE": "Reset Password",
    "WORKPLUS.RESET_PASSWORD_PAGE.PROVISIONAL_PASSWORD": "Provisional password",
    "WORKPLUS.RESET_PASSWORD_PAGE.PASSWORD": "Password",
    "WORKPLUS.RESET_PASSWORD_PAGE.CONFIRM_PASSWORD": "Confirm Password",
    "WORKPLUS.TERMS_CONDITION_PAGE.TERMS_CONDITION": "Terms & Conditions",
    "WORKPLUS.FIRST_LOGIN_PAGE.SELECT_IMAGE": "Select image",
    "WORKPLUS.FIRST_LOGIN_PAGE.SETUP_PROFILE": "Setup Profile",
    "WORKPLUS.FIRST_LOGIN_PAGE.YOUR_PASSWORD": "Your Password",
    "WORKPLUS.FIRST_LOGIN_PAGE.CONFIRM_YOUR_PASSWORD": "Confirm Your Password",
    "WORKPLUS.SETTINGS_PAGE.TITLE": "Settings",
    "WORKPLUS.SETTINGS_PAGE.INFORMATION": "Information",
    "WORKPLUS.SETTINGS_PAGE.PROFILE": "Profile",
    "WORKPLUS.SETTINGS_PAGE.WFH": "Work from Home",
    "WORKPLUS.SETTINGS_PAGE.LOCATION_NOT_SPECIFIED": "Location not specified",
    "WORKPLUS.SETTINGS_PAGE.GENERAL": "General",
    "WORKPLUS.SETTINGS_PAGE.LANGUAGE": "Language",
    "WORKPLUS.SETTINGS_PAGE.CONFIG_THEME": "Theme",
    "WORKPLUS.ME_PAGE.TITLE": "Me",
    "WORKPLUS.ME_PAGE.TASK": "Task",
    "WORKPLUS.SERVICES_PAGE.RECENTLY": "Services",
    "WORKPLUS.SERVICES_PAGE.CATEGORY": "Category",
    "WORKPLUS.SHARE_WIFI.HEAD": "Wifi",
    "WORKPLUS.NOTIFICATION_PAGE.TITLE": "Notifications",
    "WORKPLUS.GET_MONEY.SELECT_BANK": "Select the bank that wants to add a PromptPay account.",
    "WORKPLUS.GET_MONEY_FORM.CREATE": "Specify phone number or Citizen id number.",
    "WORKPLUS.GET_MONEY_FORM.CONFIRM": "Confirm",
    "WORKPLUS.GET_MONEY.CONFIRM_MESSAGE": "Are you sure to delete PromptPay",
    "WORKPLUS.GET_MONEY_FORM.PROMPT_PAY_INVALID": "Phone number or Citizen id is incorrect",
    "WORKPLUS.GET_MONEY_FORM.PROMPT_PAY_TRANSFER": "Scan QR to transfer to account",
    "WORKPLUS.VAT_BILL.COMPANY": "Company",
    "WORKPLUS.VAT_BILL.ADDRESS": "Address",
    "WORKPLUS.VAT_BILL.TAX_ID": "Tax ID",
    "WORKPLUS.VAT_BILL.TEL": "Tel",
    "WORKPLUS.VAT_BILL.FAX": "Fax",
    "WORKPLUS.DIGITAL_CONTACT.SEARCH": "Search",
    "WORKPLUS.DIGITAL_CONTACT.ALLMEMBER": "All",
    "WORKPLUS.DIGITAL_CONTACT.MYTEAM": "My Team",
    "WORKPLUS.GET_MONEY.GET_MONEY_SELECT_BANK": "Select the bank that wants to add a PromptPay account.",
    "WORKPLUS.TABS_PAGE.VOICECOMMAND": "Voice",
    "WORKPLUS.TABS_PAGE.PLENOI": "Plenoi",
    "WORKPLUS.TABS_PAGE.FINDER": "Finder",
    "WORKPLUS.TABS_PAGE.VIRTUAL_AI": "Virtual AI",
    "WORKPLUS.TABS_PAGE.QRSCAN": "Scan",
    "WORKPLUS.FINDER_PAGE.FINDER": "Finding a service",
    "WORKPLUS.NAVIGATE.OFFICE": "Office",
    "WORKPLUS.NAVIGATE.CUSTOMER": "Customer",
    "WORKPLUS.NAVIGATE.OTHER": "Other",
    "WORKPLUS.NAVIGATE.NAVIGATION": "Navigate",
    "WORKPLUS.MY_RESPONSIBILITY.DATA_NOT_FOUND": "Data not found",
    "WORKPLUS.EXP_PLUS.FEED": "EXP+",
    "WORKPLUS.EXP_PLUS.FEED_MIND": "What do you want to share?",
    "WORKPLUS.EXP_PLUS.FEED_LIKE_SO_MUCH": "and",
    "WORKPLUS.EXP_PLUS.FEED_LIKE_SO_MUCH_PEOPLES": "others",
    "WORKPLUS.EXP_PLUS.FEED_LIKE_SO_MUCH_PEOPLE": "other",
    "WORKPLUS.EXP_PLUS.FEED_MIND_CREATE": "What do you want to share?",
    "WORKPLUS.EXP_PLUS.FEED_POST": "Post",
    "WORKPLUS.EXP_PLUS.FEED_EDIT": "Save",
    "WORKPLUS.EXP_PLUS.FEED_CREATE_POST": "Create Post",
    "WORKPLUS.EXP_PLUS.FEED_EDIT_POST": "Edit Post",
    "WORKPLUS.EXP_PLUS.LIKE": "Like",
    "WORKPLUS.EXP_PLUS.LIKES": "Likes",
    "WORKPLUS.EXP_PLUS.COMMENT": "ความคิดเห็น",//Comment
    "WORKPLUS.EXP_PLUS.COMMENTS": "ความคิดเห็น",//Comments
    "WORKPLUS.EXP_PLUS.COMMENT_OPINION": "ข้อความ",//Comments
    "WORKPLUS.EXP_PLUS.COMMENT_TEANS": "ข้อความ",//Comment
    "WORKPLUS.EXP_PLUS.COMMENT_TEANSS": "ข้อความ",//Comments
    "WORKPLUS.EXP_PLUS.SHARE": "Share",
    "WORKPLUS.EXP_PLUS.WRITE_A_COMMENT": "เขียนข้อความ...",//Write a comment...
    "WORKPLUS.EXP_PLUS.WRITE_A_MSG": "Write a message...",
    "WORKPLUS.EXP_PLUS.LOAD_PREVIOUS_COMMENTS": "Load previous comments",
    "WORKPLUS.EXP_PLUS.LET_START": "Let's start",
    "WORKPLUS.EXP_PLUS.POST_EXP": "Post EXP+",
    "WORKPLUS.EXP_PLUS.SHARE_EXPERIENCE": "share your experience !",
    "WORKPLUS.EXP_PLUS.HASHTAG": "Hashtag",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE": "Select Privacy",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_REMARK_1": "Who can see your post?",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_REMARK_2": "Your post will show up in EXP+ Feed",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_CONFIRM": "Done",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_COMPANY": "Company",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_SPECIFIC": "Specific friends",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_ONLY_ME": "Only me",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_TEAM": "My Team",
    "WORKPLUS.EXP_PLUS.CHOOSE_FRIEND": "Choose Friend",
    "WORKPLUS.REWARD_STORE.YOUR_HAVE_POINT": "You have __point__ Point",
    "WORKPLUS.REWARD_STORE.YOUR_HAVE_POINTS": "You have __point__ Points",
    "WORKPLUS.REWARD_STORE.REWARD_LEFT": "Left",
    "WORKPLUS.REWARD_STORE.OUT_OF_STOCK": "Out of stock",
    "WORKPLUS.REWARD_STORE.POINTS": "Points",
    "WORKPLUS.REWARD_STORE.POINT": "Point",
    "WORKPLUS.REWARD_STORE.REWARD_REDEEM_REDEEM": "Redeem",
    "WORKPLUS.REWARD_STORE.REWARD_SEND_GIFT": "Send as gift",
    "WORKPLUS.REWARD_STORE.REWARD_REDEEM_START_DATE": "Start",
    "WORKPLUS.REWARD_STORE.REWARD_REDEEM_END_DATE": "To",
    "WORKPLUS.REWARD_STORE.REWARD_REDEEM_DESC": "To redeem this item. Please click",
    "WORKPLUS.REWARD_MY_BAG.REWARD_NAME": "Reward Name",
    "WORKPLUS.REWARD_MY_BAG.TITLE": "My Bag",
    "WORKPLUS.REWARD_MY_BAG.RECEIVED": "Received",
    "WORKPLUS.REWARD_MY_BAG.REDEEMED": "Redeemed",
    "WORKPLUS.REWARD_MY_BAG.CANCEL": "Cancelled",
    "WORKPLUS.REWARD_MY_BAG.CANCEL_BTN": "Cancel",
    "WORKPLUS.REWARD_MY_BAG.REDEEM_DATE": "Redeemed Date",
    "WORKPLUS.REWARD_MY_BAG.REDEEMED_DATE": "Received Date",
    "WORKPLUS.REWARD_MY_BAG.DELIVERED_BY": "Delivered By",
    "WORKPLUS.REWARD_MY_BAG.DELIVERED_DATE": "Delivered By",
    "WORKPLUS.REWARD_MY_BAG.REJECTED_BY": "Rejected By",
    "WORKPLUS.REWARD_MY_BAG.REJECTED_DATE": "Rejected Date",
    "WORKPLUS.REWARD_MY_BAG.CANCEL_DATE": "Cancelled Date",
    "WORKPLUS.REWARD_MY_BAG.CANCEL_BY": "Cancelled By",
    "WORKPLUS.REWARD_MY_BAG.CANCEL_REMARK": "Remark",
    "WORKPLUS.REWARD_MY_BAG.SENT_DATE": "Sent Date",
    "WORKPLUS.REWARD_MY_BAG.FROM": "From",
    "WORKPLUS.REDEMPTION": "Redemption",
    "WORKPLUS.REDEMPTION.HISTORY": "Redemption History",
    "WORKPLUS.REDEMPTION.HISTORY_BTN": "History",
    "WORKPLUS.REDEMPTION.SELECT_ALL": "Select All",
    "WORKPLUS.REDEMPTION.RECEIVE": "Deliver",
    "WORKPLUS.REDEMPTION.REJECT": "Reject",
    "WORKPLUS.REDEMPTION.REJECT_BACK": "Back",
    "WORKPLUS.REDEMPTION.REJECT_CONFIRM": "Ok",
    "WORKPLUS.REDEMPTION.REJECT_REASON": "Reason",
    "WORKPLUS.REDEMPTION.NO_ITEM": "No item!",
    "WORKPLUS.DIGITAL_BUSINESS_CARD.DOWNLOAD_FAIL": "Download fail.",
    "WORKPLUS.DIGITAL_BUSINESS_CARD.DOWNLOAD_SUCCESSFULLY": "Download successfully.",
    "WORKPLUS.TRANSACTIONSCAN.TRANSACTION_SCAN": "Usage History",
    "WORKPLUS.PROFILE_SETTING.PROFILE": "Profile",
    "WORKPLUS.PROFILE_SETTING.EDIT_PROFILE": "Edit Profile",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_PHONENUMBER": "Phone number not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_EMAIL": "Email not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_NICKNAME": "Nickname not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_STATUS": "Status not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_ADDRESS": "Address not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_FACEBOOK": "Facebook not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_LINE": "Line not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_TWITTER": "Twitter not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_INSTAGRAM": "Instagram not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_YOUTUBE": "Youtube not specified",
    "WORKPLUS.PROFILE_SETTING.NOTSPECIFIED_LINKEDIN": "LinkedIn not specified",
    "WORKPLUS.GREETING.GREETING_SAYHI": "Direct Message",
    "WORKPLUS.NOTIFICATION.TITLE": "Notifications",
    "WORKPLUS.NEWS_PAGE.NEWS": "News",
    "WORKPLUS.NEWS_DETAIL.ALL_NEWS": "All news",
    "WORKPLUS.WORK_FROM_HOME_PAGE.LOCATION_FOR_WFH": "Location for Work from Home",
    "WORKPLUS.MAPS.SEARCH_LOCATION": "Search location",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_GOOD": "Air quality is considered satisfactory, and air pollution poses little or no risk",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_MODERATE": "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution.",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_UNHEALTHY_FOR_SENSITIVE": "Members of sensitive groups may experience health effects. The general public is not likely to be affected.",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_UNHEALTHY": "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_VERY_UNHEALTHY": "Health warnings of emergency conditions. The entire population is more likely to be affected.",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_HAZARDOUS": "Health alert: everyone may experience more serious health effects",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_GOOD": "Good",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_MODERATE": "Moderate",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_UNHEALTHY_FOR_SENSITIVE": "Unhealthy for Sensitive Groups",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_UNHEALTHY": "Unhealthy",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_VERY_UNHEALTHY": "Very Unhealthy",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_STATUS_HAZARDOUS": "Hazardous",
    "WORKPLUS.AIR_QUALITY_PAGE.AIR_POLLUTION": "Pollution",
    "WORKPLUS.EF_SCORE_PAGE.NO_TARGET": "Not Achieve",
    "WORKPLUS.EF_SCORE_PAGE.TARGET_ACHIEVED": "Target __value__ Achieved!",
    "WORKPLUS.EF_SCORE_PAGE.TARGET_ACHIEVED_DESC": "__xp__ Scores to Achieve Target __level__",
    "WORKPLUS.EF_SCORE_PAGE.LATEST_UPDATE": "Latest Update",
    "WORKPLUS.ACTIVITY_LIST.ACTIVITY": "Activity",
    "WORKPLUS.ACTIVITY_LIST.COMINGSOON": "Coming Soon",
    "WORKPLUS.ACTIVITY_LIST.PREVIOUS": "Previous",
    "WORKPLUS.ACTIVITY_LIST.LEFT": "Left",
    "WORKPLUS.ACTIVITY_LIST.SEAT": "Seat",
    "WORKPLUS.ACTIVITY_DETAIL.REGISTERED": "Registered",
    "WORKPLUS.ACTIVITY_DETAIL.ALLSEAT": "Seats",
    "WORKPLUS.ACTIVITY_DETAIL.DETAIL": "Detail",
    "WORKPLUS.ACTIVITY_DETAIL.ATTENDEES": "Attendees",
    "WORKPLUS.POINT_POPUP_PAGE.POINT": "Point",
    "WORKPLUS.POINT_POPUP_PAGE.POINTS": "Points",
    "WORKPLUS.POINT_POPUP_PAGE.POINT_SMALL_SINGLE": "point",
    "WORKPLUS.POINT_POPUP_PAGE.POINT_SMALL": "points",
    "WORKPLUS.POINT_POPUP_PAGE.YOUR_HAVE_POINT": "You have __point__ Point",
    "WORKPLUS.POINT_POPUP_PAGE.YOUR_HAVE_POINTS": "You have __point__ Points",
    "WORKPLUS.POINT_POPUP_PAGE.CONGRATULATIONS": "Congratulations!",
    "WORKPLUS.POINT_POPUP_PAGE.RECEIVED_POINT": "You got points from check in.",
    "WORKPLUS.POINT_POPUP_PAGE.CHECKOUT_TIME": "Check out time",
    "WORKPLUS.POINT_POPUP_PAGE.THANK_YOU_WORK": "Thanks for your good work today.",
    "WORKPLUS.POINT_POPUP_PAGE.PRODUCTIVE_AT_8": "You worked 8 Hrs.",
    "WORKPLUS.POINT_POPUP_PAGE.PRODUCTIVE_GOT": "You worked",
    "WORKPLUS.CHECKIN_PAGE.CHECKIN": "Check in",
    "WORKPLUS.CHECKIN_PAGE.CHECKINTODAY": "Check out success",
    "WORKPLUS.CHECKIN_PAGE.CHECKOUT": "Check out",
    "WORKPLUS.CHECKIN_PAGE.CHECKIN_TIME": "Working hours",
    "WORKPLUS.CHECKIN_PAGE.CHECKEDIN": "Checked in",
    "WORKPLUS.CHECKIN_PAGE.CHECKEDOUT": "Checked out",
    "WORKPLUS.CHECKIN_PAGE.FINDFRIEND": "Find Friends",
    "WORKPLUS.CHECKIN_PAGE.PEOPLE": "Peoples",
    "WORKPLUS.CHECKIN_ME_PAGE.ME": "Me",
    "WORKPLUS.CHECKIN_TEAM_PAGE.TEAM": "My Team",
    "WORKPLUS.ACTIVITY_DETAIL.CANCLEEVENT": "Cancel",
    "WORKPLUS.ACTIVITY_DETAIL.CONFIRM_CANCLEEVENT": "Do you want to cancel your participation in this event?",
    "WORKPLUS.ACTIVITY_DETAIL.YOURCODE": "Your Code",
    "WORKPLUS.ACTIVITY_DETAIL.SPEAKER": "Speaker",
    "WORKPLUS.ACTIVITY_DETAIL.PLACE": "Place",
    "WORKPLUS.ACTIVITY_DETAIL.DATEANDTIME": "Date and Time",
    "WORKPLUS.ACTIVITY_DETAIL.REGISTER_ACTIVITY": "Do you want to register this activity",
    "WORKPLUS.ACTIVITY_DETAIL.UNREGISTER_ACTIVITY": "Do you want to Unregister this activity",
    "WORKPLUS.CHECKIN_MODAL.GOOD_MORNING": "Good morning, ",
    "WORKPLUS.CHECKIN_MODAL.GOOD_AFTERNOON": "Good Afternoon, ",
    "WORKPLUS.CHECKIN_MODAL.GOOD_EVENING": " Hi, ",
    "WORKPLUS.CHECKIN_MODAL.CHECK_IN_POINT_GOT": " You got",
    "WORKPLUS.CHECKIN_MODAL.CHECK_IN_POINT": " from on time check-in.",
    "WORKPLUS.CHECKIN_MODAL.CHECK_OUT_THANK": "Thank you, ",
    "WORKPLUS.CHECKIN_MODAL.CHECK_OUT_DETAIL": "Today you worked",
    "WORKPLUS.CHECKIN_MODAL.MINNUTE": "Minute",
    "WORKPLUS.CHECKIN_MODAL.MINNUTES": "Minutes",
    "WORKPLUS.CHECKIN_MODAL.HOUR": "Hour",
    "WORKPLUS.CHECKIN_MODAL.HOURS": "Hours",
    "WORKPLUS.CHECKIN_MODAL.HOURS_SMALL": "hours",
    "WORKPLUS.CHECKIN_MODAL.HOURS_SMALL_SINGLE": "hour",
    "WORKPLUS.CHECKIN_MODAL.HRS": "Hrs.",
    "WORKPLUS.SHARED.MARK_ALL_AS_READ": "Mark all as read",
    "WORKPLUS.SHARED.MARK_AS_READ": "Mark as Read",
    "WORKPLUS.SHARED.DELETE_ALL": "Delete all",
    "WORKPLUS.SHARED.DELETE": "Delete",
    "WORKPLUS.SHARED.TODAY": "Today",
    "WORKPLUS.SHARED.MONTH": "Month",
    "WORKPLUS.SHARED.THIS_MONTH": "This Month",
    "WORKPLUS.SHARED.PASTDAY": "Previous Day",
    "WORKPLUS.SHARED.EDIT": "Edit",
    "WORKPLUS.SHARED.SAVE": "Save",
    "WORKPLUS.SHARED.UPDATE": "Update",
    "WORKPLUS.SHARED.OPEN": "Open",
    "WORKPLUS.SHARED.NICKNAME": "Nickname",
    "WORKPLUS.SHARED.STATUS": "Status",
    "WORKPLUS.SHARED.THEME_SYSTEM": "System",
    "WORKPLUS.SHARED.THEME_LIGHT": "Light",
    "WORKPLUS.SHARED.THEME_DARK": "Dark",
    "WORKPLUS.SHARED.COMPANY_CODE": "Company",
    "WORKPLUS.SHARED.EMAIL": "Email",
    "WORKPLUS.SHARED.SUBMIT": "Submit",
    "WORKPLUS.SHARED.CONFIRM": "Confirm",
    "WORKPLUS.SHARED.CLOSE": "Close",
    "WORKPLUS.SHARED.CANCEL": "Cancel",
    "WORKPLUS.SHARED.ACCEPT": "Accept",
    "WORKPLUS.SHARED.SELECT_IMAGE": "Select image",
    "WORKPLUS.SHARED.CAMERA": "Camera",
    "WORKPLUS.SHARED.GALLERY": "Gallery",
    "WORKPLUS.SHARED.ABOUT": "About",
    "WORKPLUS.SHARED.SIGNOUT": "Sign Out",
    "WORKPLUS.SHARED.SIGNOUT_CONFIRM": "Do you want to sign out?",
    "WORKPLUS.SHARED.VERSION": "Current Version",
    "WORKPLUS.SHARED.PRESS_BACK_AGAIN": "Press back again to exit app.",
    "WORKPLUS.SHARED.POINTS": "Points",
    "WORKPLUS.SHARED.CONTENT_NOT_FOUND": "Content not found",
    "WORKPLUS.SHARED.SEARCH": "Search",
    "WORKPLUS.SHARED.SUCCESSFULLY": "Save contact successfully.",
    "WORKPLUS.SHARED.CONTACT_ERROR": "Error saving contact.",
    "WORKPLUS.SHARED.ALREADY_HAVE_CONTACT": "You already have contact.",
    "WORKPLUS.SHARED.LOAD_DATA": "Load Data",
    "WORKPLUS.SHARED.WORKPLACE": "Work Place",
    "WORKPLUS.SHARED.PHONENUMBER": "Phone Number",
    "WORKPLUS.SHARED.OF": "Of",
    "WORKPLUS.SHARED.READ": "Read",
    "WORKPLUS.SHARED.CALL_SERVICE_ERROR": "Error, Please try again.",
    "WORKPLUS.SHARED.ALL": "All",
    "WORKPLUS.SHARED.ADDRESS": "Address",
    "WORKPLUS.SHARED.REGISTER": "Register",
    "WORKPLUS.SHARED.CHECKIN": "Check in",
    "WORKPLUS.SHARED.OK": "OK",
    "WORKPLUS.POINT_HISTORY.TITLE": "My Points",
    "WORKPLUS.POINT_HISTORY.HISTORY": "History",
    "WORKPLUS.POINT_HISTORY.BALANCE": "Balance",
    "WORKPLUS.POINT_HISTORY.POINT": "Point",
    "WORKPLUS.POINT_HISTORY.POINTS": "Points",
    "WORKPLUS.POINT_HISTORY.TRANSFER_POINTS": "Transfer Points",
    "WORKPLUS.POINT_HISTORY.REWARD_STORE": "Reward Store",
    "WORKPLUS.POINT_HISTORY.DATA_NOT_FOUND": "Data not found",
    "WORKPLUS.POINT_TRANSFER.TRANSFER_POINTS": "Transfer Points",
    "WORKPLUS.POINT_TRANSFER.TRANSFER_TO": "To:",
    "WORKPLUS.POINT_TRANSFER.POINTS_AMOUNT": "Points Amount:",
    "WORKPLUS.POINT_TRANSFER.TRANSFER_POINTS_MEMO": "Memo",
    "WORKPLUS.POINT_TRANSFER.YOUR_HAVE_POINT": "You have __point__ Point",
    "WORKPLUS.POINT_TRANSFER.YOUR_HAVE_POINTS": "You have __point__ Points",
    "WORKPLUS.POINT_TRANSFER.POINT": "Points",
    "WORKPLUS.POINT_TRANSFER.POINTS": "Points",
    "WORKPLUS.DIRECT_MESSAGE.CHOOSE_FRIEND": "Choose Friend",
    "WORKPLUS.DIRECT_MESSAGE.CHOOSE_TEAM": "Choose Team",
    "WORKPLUS.DIRECT_MESSAGE.ENTER_MESSAGE": "Enter message",
    "WORKPLUS.DIRECT_MESSAGE.MESSAGE": "Message",
    "WORKPLUS.DIRECT_MESSAGE.SEND": "Send",
    "WORKPLUS.DIRECT_MESSAGE.CHOOSE_COMPANYS": "Choose Company",
    "WORKPLUS.INITIAL_GREETING.TITLE1": "Welcome to Work+",
    "WORKPLUS.INITIAL_GREETING.DESCRIPTION1": "Work+ is an intuitive work platform to connect you and your organization together.",
    "WORKPLUS.INITIAL_GREETING.TITLE2": "One Team One Goal",
    "WORKPLUS.INITIAL_GREETING.DESCRIPTION2": "Quick and easy to engage your team with Work+ to share goal, work, idea and etc.",
    "WORKPLUS.INITIAL_GREETING.TITLE3": "Productive Everyday",
    "WORKPLUS.INITIAL_GREETING.DESCRIPTION3": "Never missing! Work+ Notification immediately lets you do all important things.",
    "WORKPLUS.INITIAL_GREETING.TITLE4": "Transform Together",
    "WORKPLUS.INITIAL_GREETING.DESCRIPTION4": "Work+ Platform is designed to support all you need for work transformation.",
    "WORKPLUS.SHARED.YOU": "You",
    "WORKPLUS.SHARED.BLUETOOTH_OFF": "Bluetooth is Off",
    "WORKPLUS.WIDGET_CHECKIN.DATA_LOCATION": "Load Location Data",
    "WORKPLUS.WIDGET_CHECKIN.DATA_CHECKINS": "Load Data Check-In",
    "WORKPLUS.WIDGET_CHECKIN.CHECK_IN_WORK": "Check in",
    "WORKPLUS.SHARED.CHANGE_PASSWORD": "Change Password",
    "WORKPLUS.SHARED.CONFIRMATION_PASSWORD": "Incorrect password confirmation.",
    "WORKPLUS.SHARED.DATA_LOCATION": "Load Location Data",
    "WORKPLUS.SHARED.DATA_CHECKINS": "Load Data Check-Ins",
    "WORKPLUS.SHARED.CHECK_IN_WORK": "Check in",
    "WORKPLUS.SHARED.EXCEPTION": "Exception",
    "WORKPLUS.SHARED.WARNING": "Warning!",
    "WORKPLUS.SHARED.REMAINING_POINT": "Your remaining points are not enough to transfer.",
    "WORKPLUS.SHARED.INPUT_POINTS": "Please input your points more than 0",
    "WORKPLUS.SHARED.CHARACTERS": "Please specify no more than 50 characters.",
    "WORKPLUS.SHARED.TRANSFER_POINT": "Transfer Points",
    "WORKPLUS.SHARED.DATA_NOT_FOUND": "Data not found",
    "WORKPLUS.SHARED.ALERT": "Alert",
    "WORKPLUS.SHARED.NO_ITEM_SELECT": "No item selected!",
    "WORKPLUS.SHARED.CANCEL_REWARD": "Cancel Reward",
    "WORKPLUS.SHARED.PLEASE_REMARK": "Please fill remark.",
    "WORKPLUS.SHARED.SEND_GIFT": "Send as Gift",
    "WORKPLUS.SHARED.CHECK_INTERNET_CONNECTION": "Please check your internet connection.",
    "WORKPLUS.SHARED.DOWNLOAD": "Download",
    "WORKPLUS.SHARED.APP_UPDATE": "App update",
    "WORKPLUS.SHARED.DOWNLOAD_NEW_VERSION": "Please download the new version.",
    "WORKPLUS.SHARED.DELETE_POST": "Delete Post",
    "WORKPLUS.SHARED.EDIT_POST": "Edit Post",
    "WORKPLUS.SHARED.NO_SERVICE_FOUND": "No Service Found",
    "WORKPLUS.SHARED.SERVICE_NEARBY_OPEN": "There is no service nearby to open",
    "WORKPLUS.SHARED.RETRY": "Retry",
    "WORKPLUS.SHARED.SETUP_PROFILE": "Setup Profile",
    "WORKPLUS.SHARED.SAVE_PROFILE": "Save Profile",
    "WORKPLUS.SHARED.HAZARDOUS": "Hazardous",
    "WORKPLUS.SHARED.VERY_UNHEALTHY": "Very Unhealthy",
    "WORKPLUS.SHARED.UNHEALTHY": "Unhealthy",
    "WORKPLUS.SHARED.SENSITIVE": "Unhealthy Sensitive",
    "WORKPLUS.SHARED.MODERATE": "Moderate",
    "WORKPLUS.SHARED.GOOD": "Good",
    "WORKPLUS.SHARED.LIKE": "ชอบ",//Like
    "WORKPLUS.SHARED.CELEBRATE": "ยินดีด้วย",//Celebrate
    "WORKPLUS.SHARED.LOVE": "รักเลย",//Love
    "WORKPLUS.SHARED.INSIGHTFUL": "เข้าใจ",//Insightful
    "WORKPLUS.SHARED.CURIOUS": "สงสัย",//Curious
    "WORKPLUS.SHARED.SAD": "เศร้า",//Sad
    "WORKPLUS.SHARED.LAUGH": "สนุกสนาน",//Laugh
    "WORKPLUS.SHARED.PLEASE_CONTACT_ADMIN": "Internal Error Please Contact Admin",
    "WORKPLUS.WORDING.ERROR": "Error",
    "WORKPLUS.WORDING.SUCCESS": "Success",
    "WORKPLUS.WORDING.PLEASE_INPUT": "Please input",
    "WORKPLUS.EXP_PLUS.DELETE_POST_ANYMORE": "This post will be deleted and you won't be able to find it anymore.",
    "WORKPLUS.EXP_PLUS.DELETE_POST_AGAIN": "Delete this post failed. Please try again.",
    "WORKPLUS.DIRECT_MESSAGE.SHARE_TEAM": "Share to team",
    "WORKPLUS.DIRECT_MESSAGE.SHARE_FRIEND": "Share to friend",
    "WORKPLUS.TABS.DEVICE_NOT_SUPPORTED": "Device is not supported",
    "WORKPLUS.REWARD_STORE_DETAIL.REWARD_REDEEM": "Reward Redeem",
    "WORKPLUS.REWARD_STORE_DETAIL.REWARD_REDEMPTION": "Reward Redemption",
    "WORKPLUS.REDEMPTION.REDEMPTION_DELIVERY": "Redemption Delivery",
    "WORKPLUS.REDEMPTION.REWARD_DELIVERY_SUCCESS": "Reward Delivery Success",
    "WORKPLUS.REDEMPTION.REJECT_REWARD_SUCCESS": "Reject Reward Successfully",
    "WORKPLUS.REDEMPTION.REJECT_REWAR": "Reject Reward",
    "WORKPLUS.REDEMPTION.PLEASE_ITEM": "Please pick item.",
    "WORKPLUS.REDEMPTION.CONFIRM_REDEMP_DELIVERY": "Confirm Redemption Delivery",
    "WORKPLUS.PROFILE_SETTING.PROFILE_LOAD": "Load Profile",
    "WORKPLUS.PROFILE_SETTING.PHONE_INVALID": "Phone number Invalid",
    "WORKPLUS.PROFILE_SETTING.UPLOAD_IMAGE_SUCCESSFULLY": "Upload image successfully",
    "WORKPLUS.NOTIFICATION.DELETE_DATA": "Delete",
    "WORKPLUS.NOTIFICATION.DELETE_COMFIRM": "Do you want to delete the notification?",
    "WORKPLUS.NOTIFICATION.DELETE_NOTI": "Delete Notification",
    "WORKPLUS.NOTIFICATION_ALL.ALERT": "Confirm",
    "WORKPLUS.NOTIFICATION_ALL.READ": "Are you sure you want to mark as read?",
    "WORKPLUS.NOTIFICATION_ALL.DELETE": "Are you sure you want to delete notifications?",
    "WORKPLUS.NOTIFICATION_ALL.READ_ALL": "Are you sure you want to mark all as read?",
    "WORKPLUS.NOTIFICATION_ALL.DELETE_ALL": "Are you sure you want to delete all notifications?",
    "WORKPLUS.LOGIN_PAGE.INVALID_COMPANY_CODE": "Invalid company code",
    "WORKPLUS.RESET_PASSWORD.RESET_PASSWORD": "Reset Password",
    "WORKPLUS.RESET_PASSWORD.RESET_INCORRECT_PASSWORD": "Incorrect password confirmation.",
    "WORKPLUS.EXP_PLUS_LIST.EXP_PLUS": "EXP+",
    "WORKPLUS.CORE_BLUETOOTH.NOT_FOUND_BLUETOOTH": "Not found service. Please turn on bluetooth",
    "WORKPLUS.CORE_PHOTO.DOWNLOAD_IMAGE_LATER": "Download image fail please try again later.",
    "WORKPLUS.CORE_PHOTO.DOWNLOADING": "Downloading image...",
    "WORKPLUS.CORE_PHOTO.DOWNLOAD_SUCCESSFULLY": "Download image successfully.",
    "WORKPLUS.CORE_PHOTO.DOWNLOAD_FAIL": "Download image fail please try again later(2).",
    "WORKPLUS.AIR_QUALITY.UNABLE": "Unable to load data. Please try again.",
    "WORKPLUS.LANGUAGE.CONFIRM_SELECT_LANGUAGE": "Do you want to use the __language__ language?",
    "WORKPLUS.LANGUAGE.SETTING_LANGUAGE": "Select Language",
    "WORKPLUS.SETTINGS_PAGE.CHECKIN": "Check-in",
    "WORKPLUS.SETTINGS_PAGE.AUTO_CHECKIN": "Auto Check-in",
    "WORKPLUS.SETTINGS_PAGE.MAC_ADDRESS": "Bluetooth Mac Address",
    "WORKPLUS.SETTINGS_PAGE.INPUT_MAC_ADDRESS": "Please Input Bluetooth Mac Address",
    "WORKPLUS.CORE_NETWORK.INTERNET_CONNECTED": "Internet connected.",
    "WORKPLUS.CORE_NETWORK.INTERNET_DISCONNECT": "Please check your internet connection.",
    "WORKPLUS.MONTH.JANUARY": "January",
    "WORKPLUS.MONTH.FEBRUARY": "February",
    "WORKPLUS.MONTH.MARCH": "March",
    "WORKPLUS.MONTH.APRIL": "April",
    "WORKPLUS.MONTH.MAY": "May",
    "WORKPLUS.MONTH.JUNE": "June",
    "WORKPLUS.MONTH.JULY": "July",
    "WORKPLUS.MONTH.AUGUST": "August",
    "WORKPLUS.MONTH.SEPTEMBER": "September",
    "WORKPLUS.MONTH.OCTOBER": "October",
    "WORKPLUS.MONTH.NOVEMBER": "November",
    "WORKPLUS.MONTH.DECEMBER": "December",
    "WORKPLUS.DAY.SUN_SHORT": "Sun.",
    "WORKPLUS.DAY.MON_SHORT": "Mon.",
    "WORKPLUS.DAY.TUE_SHORT": "Tue.",
    "WORKPLUS.DAY.WED_SHORT": "Wed.",
    "WORKPLUS.DAY.THU_SHORT": "Thu.",
    "WORKPLUS.DAY.FRI_SHORT": "Fri.",
    "WORKPLUS.DAY.SAT_SHORT": "Sat.",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_COMPANY_DESC": "Anyone in my company",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_SPECIFIC_DESC": "Anyone in my team",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_ONLY_ME_DESC": "Only show to some friends",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_TEAM_DESC": "Only show to me",
    "WORKPLUS.FEELING.LIKE": "Like",
    "WORKPLUS.FEELING.CELEBRATE": "Celebrate",
    "WORKPLUS.FEELING.LOVE": "Love",
    "WORKPLUS.FEELING.INSIGHTFUL": "Insightful",
    "WORKPLUS.FEELING.CURIOUS": "Curious",
    "WORKPLUS.FEELING.SAD": "Sad",
    "WORKPLUS.FEELING.LAUGH": "Laugh",
    "WORKPLUS.CALENDAR.HOLIDAY": "Holiday",
    "WORKPLUS.CALENDAR.EVENT": "Event",
    "WORKPLUS.AIR_QUALITY_PAGE.STATUS_ITEM": "The Standard of Air Quality Index, US EPA",
    "WORKPLUS.SHARED.DELETE_DATA": "Delete",
    "WORKPLUS.SHARED.DELETE_NOTIFICATION_COMFIRM": "Do you want to delete the notification?",
    "WORKPLUS.SHARED.CHANGE_FONT_COLOR": "Font Color",
    "WORKPLUS.SHARED.CHANGE_BACKGROUND_IMAGE": "Background",
    "WORKPLUS.SHARED.SHARE": "Share",
    "WORKPLUS.SHARED.NEXT": "Next",
    "WORKPLUS.SHARED.BACK": "Back",
    "WORKPLUS.SHARED.LOGINWITHO365": "Sign in with O356",
    "WORKPLUS.SHARED.OR": "OR",
    "WORKPLUS.CORE_FINGERPRINT.TITLE": "Access to Work Plus",
    "WORKPLUS.CORE_FINGERPRINT.DESCRIPTION": "Scan for access or cancel for PIN code.",
    "WORKPLUS.SETTING.SECURITY": "Security",
    "WORKPLUS.SETTING.PIN": "PIN Code",
    "WORKPLUS.SETTING.CHANGE_PIN": "Change PIN Code",
    "WORKPLUS.SETTING.PINGERPRINT": "Fingerprint",
    "WORKPLUS.PIN.CONFIRM_PIN_INVALID": "Confirm PIN Code is invalid.",
    "WORKPLUS.PIN.FORGOT_PIN": "Forgot PIN Code",
    "WORKPLUS.PIN.ENTER_PIN": "Enter your PIN Code",
    "WORKPLUS.PIN.CONFIRM_PIN": "Confirm your PIN Code",
    "WORKPLUS.PIN.FORGOT_PIN_SEND_MAIL": "Send a new PIN Code to __email__ successfuly, Please check your email.",
    "WORKPLUS.PIN.NEW_PIN": "Set up your new PIN",
    "WORKPLUS.PIN.CONFIRM_NEW_PIN": "Re-enter your new PIN",
    "WORKPLUS.PIN.CHANGE_PIN_SUCCESS": "Change PIN successfully.",
    "WORKPLUS.SETTING.PINGERPRINT_FACE": "Fingerprint/Face ID",
    "WORKPLUS.PIN.FORGOT_REQUEST_PIN": "Request to set up new PIN",
    "WORKPLUS.CHECKIN.CHOOSE_CHECKIN_TYPE": "Please Choose Check-in Type",
    "WORKPLUS.CHECKIN.CHOOSE_CHECKOUT_TYPE": "Please Choose Check-Out Type",
    "WORKPLUS.SHARED.LOCATION": "Location",
    "WORKPLUS.SHARED.BEACON": "Beacon",
    "WORKPLUS.SHARED.QR_CODE": "QR Code",
    "WORKPLUS.SHARED.FINDER_BEACON": "Finding a beacon",
    "WORKPLUS.SHARED.POST": "Post",
    "WORKPLUS.SHARED.POSTS": "Posts",
    "WORKPLUS.SHARED.FOLLOWING": "Following",
    "WORKPLUS.SHARED.FOLLOWERS": "Followers",
    "WORKPLUS.SHARED.UNFOLLOW": "Unfollow",
    "WORKPLUS.SHARED.FOLLOW": "Follow",
    "WORKPLUS.SHARED.FOLLOWER": "Follower",
    "WORKPLUS.CHAT.TITLE": "Chat",
    "WORKPLUS.CHAT.SEND_A_PHOTO": "__name__ send a photo.",
    "WORKPLUS.SHARED.SIGNIN_LINE": "Sign in with Line",
    "WORKPLUS.SHARED.SIGNIN_FACEBOOK": "Sign in with Facebook",
    "WORKPLUS.SHARED.SIGNIN_GOOGLE": "Sign in with Google",
    "WORKPLUS.SHARED.GET_FREE_BUSINESS_CARD": "Get Free Business Card",
    "WORKPLUS.SHARED.SELECT_COMPANY_LOGO": "Upload Company Logo",
    "WORKPLUS.SHARED.INPUT_FULLNAME": "Full name",
    "WORKPLUS.SHARED.INPUT_FULLNAME_PLACEHOLDER": "Add your full name",
    "WORKPLUS.SHARED.INPUT_COMPANY": "Company",
    "WORKPLUS.SHARED.INPUT_COMPANY_PLACEHOLDER": "Add your company",
    "WORKPLUS.SHARED.INPUT_JOB_TITLE": "Job title",
    "WORKPLUS.SHARED.INPUT_JOB_TITLE_PLACEHOLDER": "Add your job title",
    "WORKPLUS.SHARED.INPUT_PHONE": "Phone",
    "WORKPLUS.SHARED.INPUT_PHONE_PLACEHOLDER": "Add your phone",
    "WORKPLUS.SHARED.INPUT_COMPANY_PHONE": "Company Phone",
    "WORKPLUS.SHARED.INPUT_COMPANY_PHONE_PLACEHOLDER": "Add your company phone",
    "WORKPLUS.SHARED.INPUT_COMPANY_ADDRESS": "Company Address",
    "WORKPLUS.SHARED.INPUT_COMPANY_ADDRESS_PLACEHOLDER": "Add your company address",
    "WORKPLUS.SHARED.INPUT_EMAIL": "Email",
    "WORKPLUS.SHARED.INPUT_EMAIL_PLACEHOLDER": "Add your email",
    "WORKPLUS.SHARED.INPUT_WEBSITE": "Website",
    "WORKPLUS.SHARED.INPUT_WEBSITE_PLACEHOLDER": "Add your website",
    "WORKPLUS.SHARED.CHANGE_BRIGHTNESS": "Brightness",
    "WORKPLUS.SHARED.CHANGE_BUSINESS_CARD_TYPE": "Card Template",
    "WORKPLUS.SHARED.WEBSITE": "About Work Plus",
    "WORKPLUS.NEWS.CREATE_NEWS": "Create News",
    "WORKPLUS.NEWS.TITLE": "Title",
    "WORKPLUS.NEWS.DETAIL": "Detail",
    "WORKPLUS.SHARED.INPUT_DETAIL": "Input Detail",
    "WORKPLUS.NEWS.IMAGE": "Image",
    "WORKPLUS.NEWS.PUBLISHER": "Publisher",
    "WORKPLUS.NEWS.STARTDATE": "Start Date",
    "WORKPLUS.NEWS.ENDDATE": "End Date",
    "WORKPLUS.NEWS.SOURCE": "News Source",
    "WORKPLUS.NEWS.INTERNAL": "Internal",
    "WORKPLUS.NEWS.EXTERNAL": "External",
    "WORKPLUS.NEWS.EXTERNAL_URL": "External URL",
    "WORKPLUS.NEWS.FILE_ATTACHMENT": "File Attachment",
    "WORKPLUS.NEWS.UPLOAD_FILE_ATTACHMENT": "File",
    "WORKPLUS.NEWS.URL": "URL",
    "WORKPLUS.NEWS.VIDEO_URL": "Video URL",
    "WORKPLUS.NEWS.STATUS": "Status",
    "WORKPLUS.NEWS.PUSH_NOTIFICATION": "Notification",
    "WORKPLUS.NEWS.ALL_EMPLOYEE": "All Employee",
    "WORKPLUS.NEWS.TO_EMPLOYEE": "To Employee",
    "WORKPLUS.NEWS.TO_TEAM": "To Team",
    "WORKPLUS.NEWS.SELECT_EMPLOYEE": "Select Employee",
    "WORKPLUS.NEWS.SELECT_TEAM": "Select Team",
    "WORKPLUS.NEWS.HIGHLIGHT": "Highlight",
    "WORKPLUS.NEWS.PLEASE_UPLOAD_IMAGE": "Please upload news image",
    "WORKPLUS.NEWS.PLEASE_FILL_PUBLISHER": "Please fill publisher",
    "WORKPLUS.NEWS.PLEASE_FILL_TARGET": "Please select target employee",
    "WORKPLUS.NEWS.INVALID_DATE": "Invalid Date",
    "WORKPLUS.SHARED.DISABLE_COMPANY_LOGO": "Disable Company Logo",
    "WORKPLUS.SHARED.ENABLE_COMPANY_LOGO": "Enable Company Logo",
    "WORKPLUS.SHARED.PLEASE_FILL_FULLNAME": "Please fill fullname",
    "WORKPLUS.SHARED.PLEASE_FILL_EMAIL": "Please fill email",
    "WORKPLUS.SHARED.PLEASE_FILL_PHONE": "Please fill phone",
    "WORKPLUS.SHARED.PLEASE_FILL_COMPANYNAME": "Please fill company name",
    "WORKPLUS.SHARED.PLEASE_FILL_JOBTITLE": "Please fill Job title",
    "WORKPLUS.SHARED.INVALID_PHONE": "Phone is invalid",
    "WORKPLUS.NEWS.EDIT_NEWS": "Edit News",
    "WORKPLUS.NEWS_VIEW.VIEW": "Views",
    "WORKPLUS.NEWS.MANAGEMENT_TITLE": "News Management",
    "WORKPLUS.NEWS_MANAGE_LIST.TITLE": "Delete News",
    "WORKPLUS.NEWS_MANAGE_LIST.CONFIRM": "Do you want to Delete News?",
    "WORKPLUS.NEWS_MANAGE_LIST.STARTDATE": "Start Date",
    "WORKPLUS.NEWS_MANAGE_LIST.ENDDATE": "End Date",
    "WORKPLUS.NEWS.SAVE_WITH_NOTI": "Save With Notification",
    "WORKPLUS.SHARED.INVALID_COMPANY_PHONE": "Company phone is invalid",
    "WORKPLUS.SHARED.INVALID_EMAIL": "Email is invalid",
    "WORKPLUS.NEWS_MANAGE_LIST.ON": "ON",
    "WORKPLUS.NEWS_MANAGE_LIST.OFF": "OFF",
    "WORKPLUS.NEWS_MANAGE_LIST.MODIFY": "Modify By",
    "WORKPLUS.SHARED.PHOTO": "Photo",
    "WORKPLUS.LOGIN.FOR_COMPANY": "For Business",
    "WORKPLUS.LOGIN.FOR_COMPANY_DESC": "Created by your IT department",
    "WORKPLUS.LOGIN.FOR_PERSONAL": "For Personal",
    "WORKPLUS.LOGIN.FOR_PERSONAL_DESC": "Created by you",
    "WORKPLUS.CHAT.CREATEGROUP": "Create Group",
    "WORKPLUS.CHAT_CREATE.CREATEGROUP": "Create Group",
    "WORKPLUS.CHAT_CREATE.CONFIRM": "Confirm",
    "WORKPLUS.SHARED.GROUPNAME": "Group Name",
    "WORKPLUS.CHAT_CREATE.ALLOW_SEARCH": "Search is allowed.",
    "WORKPLUS.CHAT_CREATE.PUBLIC_SEARCH": "Open to allow others to find you chats.",
    "WORKPLUS.SHARED.ADD_USER": "Add Member",
    "WORKPLUS.SHARED.JOIN": "Join",
    "WORKPLUS.SHARED.GROUPMEMBER": "Member",
    "WORKPLUS.SHARED.GROUPMEMBERS": "Members",
    "WORKPLUS.CHAT_LIST.PERSON": "Person",
    "WORKPLUS.CHAT_LIST.CHAT_GROUP": "Group",
    "WORKPLUS.CHAT_LIST.PUBLIC_GROUP": "Public Group",
    "WORKPLUS.CHAT_LIST.INVITE_GROUP": "Invite Group",
    "WORKPLUS.CHAT_LIST.MY_GROUP": "My Group",
    "WORKPLUS.CHAT_DETAIL.EDIT": "Edit Group",
    "WORKPLUS.CHAT_DETAIL.RENAME": "Rename a Group",
    "WORKPLUS.CHAT_DETAIL.DATA_GROUP": "Group Information",
    "WORKPLUS.CHAT_DETAIL.GROUP_MEMBER": "Group Member",
    "WORKPLUS.CHAT_EDIT_USER.GROUP_MEMBER": "Group Member",
    "WORKPLUS.CHAT_DETAIL.LEAVE_GROUP": "Leave the Group",
    "WORKPLUS.CHAT_EDIT.RECORD": "Edit",
    "WORKPLUS.CHAT_EDIT_USER.RECORD": "Edit",
    "WORKPLUS.SHARED.INVITE_IN_GROUP": "Invite Into Group",
    "WORKPLUS.SHARED.INVITE_IN_GROUPS": "Invite Into Groups",
    "WORKPLUS.CHAT_DETAIL.DELETE": "Delete Group",
    "WORKPLUS.CHAT_CREATE.ALERT": "The name must be more than 5 characters and not special characters.",
    "WORKPLUS.SHARED.IMAGE": "Image",
    "WORKPLUS.SHARED.WORKPLUS_IMAGE": "Work Plus Gallery",
    "WORKPLUS.SELECT_IMAGE_DEFAULT.PROFILE": "Work Plus Gallery",
    "WORKPLUS.SHARED.PHOTO_CAMERA_ISINVALID": "Please check your photo.",
    "WORKPLUS.SELECT_IMAGE_DEFAULT.CREATE_CONFIRM": "Successfully Created a Chat Room.",
    "WORKPLUS.SELECT_IMAGE_DEFAULT.JOIN": "You have successfully joined the group.",
    "WORKPLUS.CHAT_DETAIL.SUCCESS": "The group name was successfully edited.",
    "WORKPLUS.CHAT_EDIT_USER.SUCCESS": "Successfully edited group members.",
    "WORKPLUS.CHAT_DETAIL.IMAGE_SUCCESS": "You have successfully changed the picture.",
    "WORKPLUS.CHAT_DETAIL.CONFIRM_DELETE": "Confirm group deletion",
    "WORKPLUS.CHAT_DETAIL.DELETE_SUCCESS": "You have successfully deleted the group.",
    "WORKPLUS.CHAT_DETAIL.CONFIRM_LEAVE": "Confirm leaving the group",
    "WORKPLUS.CHAT_DETAIL.LEAVE_SUCCESS": "You have successfully left the group.",
    "WORKPLUS.CHAT_CREATE.IMAGE_SIZE": "Image size up to 5MB",
    "WORKPLUS.CHAT_CREATE.DUPLICATE": "Group name already exist",
    "WORKPLUS.CHAT_JOIN.CREATE_CONFIRM": "Already joined a group",
    "WORKPLUS.CHAT_JOIN.LEAVE_GROUP": "This group no longer exists.",
    "WORKPLUS.SHARED.SIGNIN_APPLE": "Sign in with Apple",
    "WORKPLUS.SHARED.INVITING": "Inviting",
    "WORKPLUS.CHAT_ROOM_SHARE_LOCATION.LOCATION": "Location",
    "WORKPLUS.CHAT_LIST.FRIEND": "Friend",
    "WORKPLUS.CHAT.SEND_A_FILE": "__name__ send a file.",
    "WORKPLUS.CHAT.SEND_A_LOCATION": "__name__ send a location.",
    "WORKPLUS.CHECKIN_PAGE.REMINDER": "Good morning working day?? <br>Will you check in now?",
    "WORKPLUS.CONSENT.REQUIRED": "*You must accept to this consent.",
    "WORKPLUS.SHARED.REJECT": "Reject",
    "WORKPLUS.SHARED.DECLINE": "Decline",
    "WORKPLUS.SHARED.DONE": "Done",
    "WORKPLUS.FILE.FILE_SIZE_ERROR": "File size up to __fileSize__MB",
    "WORKPLUS.FILE.MAX_IMAGE": "Maximum of __fileMax__ images",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_PUBLIC": "Public",
    "WORKPLUS.EXP_PLUS.TARGET_AUDIENCE_PUBLIC_DESC": "Show Everyone",
    "WORKPLUS.EXP_PLUS.INFLUENCER_TITLE": "Influencer",
    "WORKPLUS.SHARED.RECENT": "Recent",
    "WORKPLUS.LOGIN.PERMANENT_EMPLOYEE": "Permanent Employee",
    "WORKPLUS.LOGIN.TEMPORARY_EMPLOYEE": "Temporary Employee",
    "WORKPLUS.SHARED.VERIFICATION": "Verification",
    "WORKPLUS.SHARED.FILL_PHONENUMBER": "Please enter your phone number",
    "WORKPLUS.SHARED.OTP_DESCRIPTION": "You will receive an OTP code via SMS __PHONENUMBER__. Please key in the code and verify.",
    "WORKPLUS.SHARED.REFERENCE": "Reference NO : __REFERENCE_NO__",
    "WORKPLUS.SHARED.RESEND_AGAIN": "Resend Again",
    "WORKPLUS.SHARED.OTHER": "Other",
    "WORKPLUS.EF_SCORE_PAGE.TEAM": "My Team",
    "WORKPLUS.SHARED.OTP": "OTP",
    "WORKPLUS.PROFILE_SETTING.ADDRESS": "Address",
    "WORKPLUS.PROFILE_SETTING.PHONE": "Phone Number",
    "WORKPLUS.PROFILE_SETTING.MAIL": "Email",
    "WORKPLUS.PROFILE_SETTING.PERSONAL_PROFILE": "Personal Profile",
    "WORKPLUS.PROFILE_SETTING.WORK_PROFILE": "Work Profile",
    "WORKPLUS.ACTIVITY_LIST.NOT_LIMITED": "Not Limited",
    "WORKPLUS.PIN.FORGOT_PIN_SEND_PHONENUMBER": "A new PIN has been sent to __phoneNumber__ Please check your SMS.",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.EDIT_GROUP": "Edit Group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.LEAVE_GROUP": "Leave Group",
    "WORKPLUS.EXP_PLUS_GROUP.MEMBER": "Member",
    "WORKPLUS.EXP_PLUS_GROUP.NOTIFICATION_MASSAGE": "You want to delete",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.CREATE_GROUP": "Create Group",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.EDIT_GROUP": "Edit Group",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.ADD_PHOTO": "Add Cover Photo",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.NAME_GROUP": "Name",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.NAME_GROUP_PLACEHOLDER": "Name your group",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.COVER_PHOTO": "Cover Photo",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.CHANGE_PHOTO": "Change Cover Photo",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.REMOVE_PHOTO": "Remove Cover Photo",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.PRIVACY": "Privacy",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.PRIVATE": "Private",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.PUBLIC": "Public",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.PUBLIC_PLACEHOLDER": "Anyone can see who's in the group and what they post.",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.PRIVATE_PLACEHOLDER": "Only members ca see who's in the group and what they post.",
    "WORKPLUS.EXP_PLUS_GROUP.GROUPS": "Groups",
    "WORKPLUS.EXP_PLUS_GROUP.MY_GROUPS": "My Group",
    "WORKPLUS.EXP_PLUS_GROUP.ALL_GROUPS": "All Group",
    "WORKPLUS.EXP_PLUS_GROUP.SEE_ALL": "See All",
    "WORKPLUS.EXP_PLUS_GROUP.SEARCH": "Group Search",
    "WORKPLUS.EXP_PLUS_GROUP.JOIN": "Join",
    "WORKPLUS.EXP_PLUS_GROUP.JOINED": "Joined",
    "WORKPLUS.EXP_PLUS_GROUP.CANCEL": "Cancel",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.PRIVATE": "Private Group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.PUBLIC": "Public Group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.MEMBERS": "__member__ Members",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.REQUESTS": "Member Requests",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.INVITE": "Invite",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.CONFIRM_LEAVE": "Confirm leaving the group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.CONFIRM_DELETE": "Confirm delete the group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.DELETE_GROUP": "Delete Group",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.NOTI_TITTLEDATA": "Please fill out the information.",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.NOTI_TITLEGROUP": "This group name already exists.",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.INVITE_JOIN": "Invite to join the group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.INVITE_JOIN_GROUP": "Successfully invited to join the __mygroup__ group",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.THIS_GROUP_PRIVATE": "This Group is Private",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.THIS_GROUP_PRIVATE_DETAIL": "Join the group to view or participate in discussions",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.JOINED": "You have successfully joined the group.",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS": "Requests",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS.APPROVE": "Approve",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS.DECLINE": "Decline",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS.APPROVEALL": "Approve all",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS.DECLINEALL": "Decline all",
    "WORKPLUS.EXP_PLUS_GROUP_REQUESTS.INVITE_BY": "Invited by",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.DECLINE": "You have declined to join this group.",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.NAME_YOUR_GROUP": "Name your Group",
    "WORKPLUS.EXP_PLUS_GROUP_CREATE.OPTIONAL": "Optional",
    "WORKPLUS.SHARED.COPY_TO_CLIPBOARD": "Copy to Clipboard",
    "WORKPLUS.EXP_PLUS_GROUP.ADMIN": "Admin Invitation",
    "WORKPLUS.EXP_PLUS_GROUP.ADMIN_INVITE": "invited you to become an admin",
    "WORKPLUS.SHARED.MEMBER": "Members",
    "WORKPLUS.SHARED.ADMIN": "Admins",
    "WORKPLUS.SHARED.INVITED": "Invited",
    "WORKPLUS.SHARED.ADD_ADMIN": "Add Admin",
    "WORKPLUS.EXP_PLUS_GROUP.NO_ADMIN": "This group doesn 't have any admins or moderators right now, but you can make yourself an admin.",
    "WORKPLUS.EXP_PLUS_GROUP.SET_ADMIN": "Become admin",
    "WORKPLUS.EXP_PLUS_GROUP_DETAIL.LEAVE": "You have left this group.",
    "WORKPLUS.EXP_PLUS_GROUP.ADMIN_JOINED": "__newAdmin__ has been invited as an administrator.",
    "WORKPLUS.SHARED.SERVICE_NOT_FOUND": "Service not found.",
    "WORKPLUS.REWARD_STORE.REWARD": "Reward",
    "WORKPLUS.REWARD_STORE.FILTER_LATEST": "Latest",
    "WORKPLUS.REWARD_STORE.FILTER_POINT_LOWHIGHT": "Point (lowest to highest)",
    "WORKPLUS.REWARD_STORE.FILTER_POINT_HIGHLOW": "Point (highest to lowest)",
    "WORKPLUS.REWARD_STORE.FILTER_POPULAR": "Popular",
    "WORKPLUS.SHARED.FILTER": "Filter",
    "WORKPLUS.FLASHCARD.TITLE": "Flash Card",
    "WORKPLUS.FLASHCARD.TOP": "Top Rating",
    "WORKPLUS.FLASHCARD.LAST": "Lastest Cards",
    "WORKPLUS.SHARED.OPEN_WEBSITE": "Open Website",
    "WORKPLUS.SHARED.YOUR_RATING": "Your Rating",
    "WORKPLUS.HOME_PAGE.AUTOMATE": "Automate",
    "WORKPLUS.SAHRE.SEE_MORE": "See more",
    "WORKPLUS.CHAT.IMAGE": "Image",
    "WORKPLUS.CHAT.FILE": "File",
    "WORKPLUS.CHAT.NOTE": "Note",
    "WORKPLUS.CHAT.CREATE_NOTE": "Create Note",
    "WORKPLUS.CHAT.EDIT_NOTE": "Edit Note",
    "WORKPLUS.CHAT.VIEW_NOTE": "View Note",
    "WORKPLUS.CHAT.DOWLOAD": "Download",
    "WORKPLUS.SHARED.CREATE": "CREATE",
    "WORKPLUS.WIDGET.UPCOMMINGEVENTS": "Upcoming Events",
    "WORKPLUS.WIDGET.WORKS": "Works",
    "WORKPLUS.WIDGET.ROOMS": "Rooms",
    "WORKPLUS.WIDGET.CHANNELS": "Channels",
    "WORKPLUS.WIDGET.ALBUM": "Album",
    "WORKPLUS.WIDGET.LIST": "Lists",
    "WORKPLUS.HOME_PAGE.SERVICE_REQUEST": "Service Requests",
    "WORKPLUS.HOME_PAGE.WORK": "Work",
    "WORKPLUS.WIDGET.DIRECTORY": "Directory",
    "WORKPLUS.WIDGET.TEAM": "Team",
    "WORKPLUS.SHARED.SEARCHING": "Search information in Work Plus.",
    "WORKPLUS.REWARD_STORE.REDEEMPOINT": "Use your points to redeem rewards.",
    "WORKPLUS.REWARD_STORE.REDEEMPAYMENT": "Pay through online channels to receive the product.",
    "WORKPLUS.SHARED.PRICE": "Price",
    "WORKPLUS.SHARED.BAHT": "Baht",
    "WORKPLUS.REWARD_STORE.NOT_ENOUGH": "You need __point__ points to be enough.",
    "WORKPLUS.REWARD_STORE.TRUEMONEYWALLET": "TrueMoney Wallet",
    "WORKPLUS.REWARD_STORE.YOURPHONE": "Enter your phone number",
    "WORKPLUS.SHARED.HOME_PAGE": "Home Page",
    "WORKPLUS.SHARED.STANDARD": "Standard",
    "WORKPLUS.SHARED.WIDGETS": "Widgets",
    "WORKPLUS.SHARED.UNSENT_MESSAGE": "Unsend Message",
    "WORKPLUS.SHARED.FILE_NOT_SUPPORT": "This file is not supported.",
    "WORKPLUS.SHARED.DECLINE_CONFIRM": "You want to decline this invitation?",
    "WORKPLUS.SHARED.ACKNOWLEDGE": "Acknowledge",
    "WORKPLUS.REWARD.PAYMENT_FAIL": "Payment error occurred. Please try again.",
    "WORKPLUS.SHARED.TITLECONFIRM": "Read this news.",
    "WORKPLUS.SHARED.CONFIRMNEW": "Please confirm to read this news.",
    'WORKPLUS.POINT_POPUP_PAGE.BATH': 'Baht',
    'WORKPLUS.FLASHCARD.GOTO': 'Open',
    'WORKPLUS.REWARD_REDEEM.COMFIRM_REDEEM': 'Do you want to use __point__ to redeem',
    'WORKPLUS.REWARD_REDEEM.COMFIRM_REDEEM_CASH': 'Do you want to use __point__ baht to redeem',
    'WORKPLUS.PROFILE.COMPANIES': 'Companies',
    'WORKPLUS.SHARED.CHEKACCEPT': "Please accept to read this news.",
    'WORKPLUS.SHARED.REPORT': "Report",


    'WORKPLUS.SHARED.PRETEST': 'Pretest',
    'WORKPLUS.SHARED.POSTTEST': 'Posttest',
    "WORKPLUS.SHARED.PRETEST_DESC": "Answering questions before reading to assess the reader's initial knowledge. and processed after successful reading.",
    "WORKPLUS.SHARED.POSTTEST_DESC": "Answering questions after reading to assess the reader's initial knowledge. and processed after successful reading.",
    'WORKPLUS.SHARED.START_QUIZ': 'Start Quiz',
    'WORKPLUS.SHARED.SEND_ANSWER': 'Send Answer',
    'WORKPLUS.SHARED.VIEW_RESULT': 'View Result',
    'WORKPLUS.SHARED.ACHIEVEMENT': 'Achievement',
    'WORKPLUS.SHARED.COMPLETED': 'You have completed the test.',
    'WORKPLUS.SHARED.VIDEO_COMPLETED': 'You have watched this video.',
    'WORKPLUS.SHARED.POSTTEST_PASS': "Before taking the card you must passe the Post-Test of    ",
   
    'WORKPLUS.SHARED.DEPARTMENT' : 'Department',
    'WORKPLUS.SHARED.EMPLOYEES' : 'Employees',
   
    // "WORKPLUS.SHARED.PRETEST": "แบบทดสอบสอบก่อนเรียน",
    // "WORKPLUS.SHARED.POSTTEST": "แบบทดสอบสอบหลังเรียน",
    // "WORKPLUS.SHARED.PRETEST_DESC": "ร่วมตอบคำถามก่อนการอ่านเพื่อประเมินความรู้เบื้องต้นของผู้อ่าน และนำไปประมวลผลหลังจากที่ได้อ่านเรียบร้อยแล้ว",
    // "WORKPLUS.SHARED.POSTTEST_DESC": "ร่วมตอบคำถามหลังการอ่านเพื่อประเมินความรู้เบื้องต้นของผู้อ่าน และนำไปประมวลผลหลังจากที่ได้อ่านเรียบร้อยแล้ว",
    // "WORKPLUS.SHARED.START_QUIZ": "เริ่มทำแบบทดสอบ",
    // "WORKPLUS.SHARED.SEND_ANSWER": "ส่งคำตอบ",
    // "WORKPLUS.SHARED.ACHIEVEMENT": "ความสำเร็จ",
    // "WORKPLUS.SHARED.COMPLETED":"คุณทำแบบทดสอบเรียบร้อยแล้ว",
    // "WORKPLUS.SHARED.VIDEO_COMPLETED": "คุณดูวิดีโอนี้แล้ว"
}
